import axiosInstance from "../api/axiosInstance";

const isArchivedQuestionV2 = (item) =>
  String(item?.status || "").trim().toLowerCase() === "archived";

/**
 * QuestionV2 Service
 *
 * Parallel data source for V2 questions generated by MD Automation.
 * Uses the same axiosInstance (and therefore the same Token + JWT auth)
 * as every other API call in dingo_user.
 */

/**
 * Fetch all QuestionV2 entries for a given lesson.
 *
 * @param {number} lessonId - The legacy lesson PK.
 * @returns {Promise<{isSuccessful: boolean, data: Array, error?: string}>}
 */
export const listQuestionsV2 = async (lessonId) => {
  try {
    const response = await axiosInstance.post("api/questions-v2/list", {
      lessonId,
    });

    const items = response?.data?.data ?? response?.data ?? [];
    const normalizedItems = Array.isArray(items) ? items : [];

    return {
      isSuccessful: true,
      data: normalizedItems.filter((item) => !isArchivedQuestionV2(item)),
    };
  } catch (error) {
    console.warn("[QuestionV2] listQuestionsV2 failed:", error?.message);
    return {
      isSuccessful: false,
      data: [],
      error: error?.response?.data?.message || error?.message || "Unknown error",
    };
  }
};

/**
 * Fetch the full detail for a single QuestionV2.
 *
 * @param {number} id - The QuestionV2 primary key.
 * @returns {Promise<{isSuccessful: boolean, data: object|null, error?: string}>}
 */
export const getQuestionV2 = async (id) => {
  try {
    const response = await axiosInstance.post("api/questions-v2/detail", {
      id,
    });

    const detail = response?.data?.data ?? response?.data ?? null;

    return {
      isSuccessful: true,
      data: isArchivedQuestionV2(detail) ? null : detail,
    };
  } catch (error) {
    console.warn("[QuestionV2] getQuestionV2 failed:", error?.message);
    return {
      isSuccessful: false,
      data: null,
      error: error?.response?.data?.message || error?.message || "Unknown error",
    };
  }
};
